import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { SSOItem } from './styles';
import Link from 'next/link';

const createLocation = (to, from = '') => ({ pathname: to, query: { from } });

const UnauthenticatedMenu = () => {
  const { t } = useTranslation('header');
  const { pathname, query } = useRouter();

  const isResidences = pathname.includes('/residences');
  const fromInferred = isResidences ? 'uniresidences' : query?.from;

  return (
    <SSOItem>
      <Link href={createLocation('/login', query?.from)} prefetch={false} className="login">
        {t('header:Log in')}
      </Link>
      <Link href={createLocation('/signup', fromInferred)} prefetch={false} className="signup">
        {t('header:Sign up')}
      </Link>
    </SSOItem>
  );
};

export default UnauthenticatedMenu;
